import { render, staticRenderFns } from "./ColorField.vue?vue&type=template&id=0a456578&scoped=true"
import script from "./ColorField.vue?vue&type=script&lang=js"
export * from "./ColorField.vue?vue&type=script&lang=js"
import style0 from "./ColorField.vue?vue&type=style&index=0&id=0a456578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a456578",
  null
  
)

export default component.exports